import { render, staticRenderFns } from "./sjProfitRpt.vue?vue&type=template&id=c32ec196&scoped=true&"
import script from "./sjProfitRpt.vue?vue&type=script&lang=js&"
export * from "./sjProfitRpt.vue?vue&type=script&lang=js&"
import style0 from "./sjProfitRpt.vue?vue&type=style&index=0&id=c32ec196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32ec196",
  null
  
)

export default component.exports